<!--考研大纲  -->
<template>
  <div class="page">
    <img
      class="main"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/main.png"
      alt=""
    />
    <div class="major">
      <div
        class="subject"
        :class="{ active: idx === k }"
        @click="changeParent(item, k)"
        v-for="(item, k) in subjectList"
        :key="k"
      >
        {{ item.majorName }}
      </div>
    </div>
    <div class="major-sub" v-if="childMajorList.length">
      <div
        class="major"
        :class="{ active: subIdx === k }"
        v-for="(item, k) in childMajorList"
        @click="changeChild(item, k)"
        :key="k"
      >
        {{ item.majorName }}
      </div>
    </div>
    <div class="section">
      <div class="tab" :class="{ active: show === 2 }">
        <div v-for="(item, k) in navTab" :key="k" @click="changeNav(k)">
          <img :src="item.img" alt="" />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="content">
        <Pdf v-if="show === 1" :pdfUrl="contentInfo.imgUrls" />
        <Pdf v-else :pdfUrl="contentInfo.pdfUrl" />
        <h4>
          {{
            (show === 1 && !contentInfo.imgUrls) || (show === 2 && !contentInfo.pdfUrl)
              ? `${show===1?'大纲':'备考策略'}未发布,敬请期待`
              : ''
          }}
        </h4>
      </div>
    </div>
    <div class="foot">
      <div class="box" @click="openChat">
        <div>
          <span>25考研</span>
          <p>获取冲刺锦囊</p>
        </div>
        <div>
          <span>26考研</span>
          <p>获取全年备考计划</p>
        </div>
      </div>
    </div>
    <div
      v-if="(show === 1 && contentInfo.imgUrls) || (show === 2 && contentInfo.pdfUrl)"
      class="downFile"
      @click="downFile"
    >
      保存文件
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { subjectList, navTab } from './outline';
import Pdf from './components/pdf.vue';
export default {
  components: {
    Pdf,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      subjectList,
      childMajorList: [],
      idx: 0,
      subIdx: 0,
      navTab,
      contentInfo: {},
      show: 1, // 1图片 2 文件
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    getMathInfo() {
      const { imgUrls, pdfUrl } = this.subjectList[0];
      this.childMajorList = [];
      this.contentInfo = { imgUrls, pdfUrl };
    },
    changeParent(item, index) {
      const { child, imgUrls, pdfUrl } = item;
      this.idx = index;
      this.subIdx = 0;
      this.contentInfo = {};
      this.childMajorList = child || [];
      if (this.childMajorList.length) {
        const temp = this.childMajorList[0];
        this.contentInfo = { imgUrls: temp.imgUrls, pdfUrl: temp.pdfUrl };
      } else {
        this.contentInfo = { imgUrls, pdfUrl };
      }
      this.show = 1;
    },
    changeChild(item, index) {
      const { imgUrls, pdfUrl } = item;
      this.contentInfo = {};
      this.subIdx = index;
      this.contentInfo = { imgUrls, pdfUrl };
      this.show = 1;
    },
    changeNav(i) {
      this.show = i + 1;
    },
    openChat() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66d573806758660001cfeb07';
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      if (this.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    downFile() {
      const { pdfUrl, imgUrls } = this.contentInfo;
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.openPdf(this.show === 1 ? imgUrls : pdfUrl);
    },
    openPdf(pdfUrl) {
      if (this.isApp) {
        this.$sendToApp('openBrowser', { url: pdfUrl }, false);
        return;
      }
      const fileName = this.extractStringBetween(pdfUrl,'zyk/','.pdf');
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/professionalCourseBank/openPdfFile/openPdfFile?pdfUrl=${pdfUrl}&fileName=${decodeURIComponent(fileName)}`,
        });
        return;
      }
      window.open(pdfUrl);
    },
    extractStringBetween(source, start, end) {
      const regex = new RegExp(start + '(.*?)' + end, 's');
      const match = source.match(regex);
      return match ? match[1] : '';
    },
    openImg() {
      this.$toast('长按/截图保存图片');
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/examOutline/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/examOutline' },
        });
      }
    },
  },
  created() {},
  mounted() {
    this.getMathInfo();
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    document.title = '考研大纲';
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 190px;
  background: #304299;
  .main {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 0;
  }
  .major {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    margin-left: 27px;
    overflow-x: scroll;
    white-space: nowrap;
    .subject {
      flex: 0 0 auto;
      box-sizing: border-box;
      width: 141px;
      height: 76px;
      margin-right: 7px;
      color: #304299;
      font-weight: 500;
      font-size: 25px;
      line-height: 70px;
      text-align: center;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/major2.png')
        no-repeat;
      background-size: 100%;
    }
    .subject.active {
      height: 76px;
      color: #fff;
      line-height: 70px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/major1.png')
        no-repeat;
      background-size: 100%;
    }
  }
  .major-sub {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    align-items: center;
    width: 678px;
    height: 58px;
    margin: 22px auto 0;
    overflow-x: scroll;
    white-space: nowrap;
    background: #fff;
    border-radius: 14px;
    .major {
      position: relative;
      flex: 0 0 auto;
      height: 58px;
      margin-right: 15px;
      padding: 0 18px;
      color: #7687a9;
      font-weight: 400;
      font-size: 25px;
      line-height: 58px;
    }
    .major.active {
      color: #5871ff;
      font-weight: 400;
      font-size: 25px;
    }
    .major.active::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      width: 29px;
      height: 7px;
      margin: 0 auto;
      background: #5871ff;
      border-radius: 4px;
      content: '';
    }
  }
  .section {
    width: 678px;
    margin: 22px auto;
    background: #fff;
    border-radius: 14px;
    .tab.active {
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/tab-bg1.png')
        no-repeat;
      background-size: 100%;
    }
    .tab {
      display: flex;
      width: 100%;
      height: 83px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/examOutline/tab-bg2.png')
        no-repeat;
      background-size: 100%;
      > div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        img {
          width: 36px;
          height: 36px;
        }
        span {
          padding-left: 11px;
          color: #304299;
          font-weight: 500;
          font-size: 25px;
        }
      }
    }
    .content {
      padding: 0 29px 29px 29px;
      h4 {
        padding: 200px 0;
        color: #999;
        font-weight: 400;
        font-size: 28px;
        text-align: center;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 185px;
    background: #fff;
    .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding: 0 36px;

      > div {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        width: 330px;
        height: 87px;
        background: linear-gradient(180deg, #00b0ff 0%, #0078ff 100%);
        border-radius: 14px;
        box-shadow: inset 0 0 11px 0 rgba(255, 255, 255, 0.5);
        span {
          color: #fff;
          font-weight: 500;
          font-size: 22px;
          line-height: 31px;
        }
        p {
          width: 100%;
          color: #fff;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
          text-align: center;
        }
      }
    }
  }
  .downFile {
    position: fixed;
    right: 36px;
    bottom: 220px;
    z-index: 10;
    height: 54px;
    padding: 0 12px;
    color: #fff;
    font-size: 22px;
    line-height: 54px;
    text-align: center;
    background: linear-gradient(306deg, #ff551c 0%, #ff7f41 100%);
    border-radius: 181px 0 0 181px;
  }
}
</style>
